import { render } from "./ProjectSettingsSideNav.vue?vue&type=template&id=3b35ee2c"
import script from "./ProjectSettingsSideNav.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__